import { useMemo } from 'react';
import { isReferralWithdrawn } from '../utils/referralStatus';

/**
 * Why a clinician's screen has to stop (TDI-475).
 *
 * Two signals, and the second usually arrives first. When the family
 * withdraws consent the server clears clinicalAccessGranted, so the
 * security rules deny the provider's live listener before the screen ever
 * sees the withdrawn record: the listener errors with permission-denied.
 * Only the support side, who may still read a withdrawn record (TDI-481),
 * sees the record itself flip to withdrawn.
 *
 * Returns { stopped, reason }: reason is 'withdrawn' when the record says
 * so, 'access-lost' when the rules shut the door, or null.
 */
export default function useConsentWithdrawnStop({ patientRecord, listenerError }) {
  return useMemo(() => {
    if (patientRecord && isReferralWithdrawn(patientRecord)) {
      return { stopped: true, reason: 'withdrawn' };
    }
    const code = String(listenerError?.code || listenerError || '');
    if (code.includes('permission-denied')) {
      return { stopped: true, reason: 'access-lost' };
    }
    return { stopped: false, reason: null };
  }, [patientRecord, listenerError]);
}
